import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { AdDetails, AdTypeIcon, Icon, SocialNetworkIcon, Stat } from 'components';
import * as styles from './AdDashboardCard.scss';
import Toggle from 'material-ui/Toggle';
import ReactTooltip from 'react-tooltip';
import { setAdCampaignStatus, setAdStatus, getAdResultsCSV } from 'redux/modules/ads';
import { convertAdToRedux } from 'redux/modules/adBuilder';
import fileDownload from 'js-file-download';
import { connect, Provider, ReactReduxContext } from 'react-redux';

var humanFormat = require('human-format');

var moment = require('moment');

var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});
var AdDashboardCard = (_dec = connect(function (state, ownProps) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  setAdCampaignStatus: setAdCampaignStatus,
  setAdStatus: setAdStatus,
  convertAdToRedux: convertAdToRedux,
  getAdResultsCSV: getAdResultsCSV
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdDashboardCard, _Component);

  var _super = _createSuper(AdDashboardCard);

  function AdDashboardCard(props) {
    var _this;

    _classCallCheck(this, AdDashboardCard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatNumber", function (num) {
      if (num > 9999) {
        return humanFormat(num, {
          scale: numberFormatScale
        });
      }

      return Number(num).toLocaleString();
    });

    _defineProperty(_assertThisInitialized(_this), "formatObjective", function (obj) {
      if (!obj) {
        return '';
      }

      var parts = obj.split('_');
      var words = [];
      parts.forEach(function (word) {
        words.push("".concat(word.charAt(0).toUpperCase()).concat(word.slice(1).toLowerCase()));
      });
      return words.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAdDetailModal", function () {
      _this.setState({
        showDetails: !_this.state.showDetails
      });
    });

    _defineProperty(_assertThisInitialized(_this), "prettyPrintAdStatus", function (status) {
      switch (status) {
        case 'CAMPAIGN_PAUSED':
          return "This ad's campaign is paused.";

        case 'PENDING_REVIEW':
          return 'This ad is pending review.';

        case 'PAUSED':
          return 'This ad is paused';

        case 'DELETED':
          return 'This ad has been deleted.';

        case 'DISAPPROVED':
          return 'This ad has been disapproved by Facebook.';

        case 'PREAPPROVED':
          return 'This ad has been preapproved by Facebook.';

        case 'PENDING_BILLING_INFO':
          return 'This ad will run when the billing has been updated.';

        case 'ARCHIVED':
          return 'This ad has been archived.';

        case 'ADSET_PAUSED':
          return "This ad's adset has been paused.";

        default:
          return "".concat(status.toLowerCase().replace(/_/g, ' '));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchResults", function (adId) {
      _this.props.getAdResultsCSV(_this.props.organization.id, adId).then(function (result, arg2) {
        fileDownload(result.data, 'Ad Results.csv');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getGlobalAdInsights", function (insights) {
      if (insights && Object.keys(insights).length > 0 && !insights.hasOwnProperty('impressions')) {
        // new format (by platform)
        if (insights.summary) {
          return _objectSpread({}, insights.summary);
        }

        var data = {
          impressions: 0,
          cost_per_total_action: {
            val: 0,
            count: 0
          },
          spend: 0
        };
        Object.keys(insights).forEach(function (key) {
          var _insights$key = insights[key],
              impressions = _insights$key.impressions,
              cost_per_total_action = _insights$key.cost_per_total_action,
              spend = _insights$key.spend;

          if (!isNaN(parseInt(impressions))) {
            data.impressions += parseInt(impressions);
          }

          if (!isNaN(parseFloat(spend))) {
            data.spend += parseFloat(spend);
          }

          if (!isNaN(parseFloat(cost_per_total_action))) {
            data.cost_per_total_action.val += parseFloat(cost_per_total_action);
            data.cost_per_total_action.count += 1;
          }
        });
        data.cost_per_total_action = data.cost_per_total_action.val / data.cost_per_total_action.count;
        return data;
      } else if (insights && Object.keys(insights).length > 0 && insights.hasOwnProperty('impressions')) {
        // old format (root object)
        return insights;
      } // idk what this is


      return {};
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _this.state = {
      showDetails: false
    };
    return _this;
  }

  _createClass(AdDashboardCard, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var handleCardClick = this.props.handleCardClick ? this.props.handleCardClick : this.toggleAdDetailModal;
      var adDetails = this.props.adDetails;
      var insights = adDetails.insights;
      var creative = adDetails.creative;
      var imageUrl = creative.thumbnail_url;

      if (creative.object_attachments) {
        for (var i = 0; i < creative.object_attachments.length; i++) {
          if (creative.object_attachments[i].media) {
            imageUrl = creative.object_attachments[i].media[Object.keys(creative.object_attachments[i].media)[0]].src;
            break;
          }
        }
      }

      var defaultPlatformInsights = this.getGlobalAdInsights(insights);

      var displayRightData = function () {
        return defaultPlatformInsights.hasOwnProperty('impressions') || defaultPlatformInsights.hasOwnProperty('cpc') || defaultPlatformInsights.hasOwnProperty('spend');
      }();

      var modalActions = adDetails.campaign.objective === 'LEAD_GENERATION' ? [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Export Results",
        onClick: function onClick() {
          return _this2.fetchResults(adDetails.id);
        }
      })] : [];
      var adTitleLargeText = /*#__PURE__*/React.createElement("span", {
        className: styles.goalLargeText
      }, this.formatObjective(adDetails.campaign.objective), ' ', this.props.type !== 'upcoming' && this.props.adDetails.name && '|');
      var adTitleSmallText = this.props.type === 'upcoming' ? null : /*#__PURE__*/React.createElement("span", {
        className: styles.goalSmallText
      }, this.props.adDetails.name);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.card,
        style: this.props.style
      }, /*#__PURE__*/React.createElement(ReactTooltip, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.goalWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.type === 'inProgress' ? 'col-xs-10' : 'col-xs-12',
        onClick: handleCardClick
      }, /*#__PURE__*/React.createElement(AdTypeIcon, {
        style: {
          "float": 'left'
        },
        adType: adDetails.campaign.objective,
        size: "medium"
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          height: 28
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.goal
      }, adTitleLargeText, adTitleSmallText))), this.props.type === 'inProgress' && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2"
      }, /*#__PURE__*/React.createElement(Toggle, {
        trackSwitchedStyle: {
          backgroundColor: '#5DE359'
        },
        trackStyle: {
          backgroundColor: '#ED6678'
        },
        thumbStyle: {
          backgroundColor: '#F5F5F5'
        },
        thumbSwitchedStyle: {
          backgroundColor: '#F5F5F5'
        },
        "data-tip": this.prettyPrintAdStatus(adDetails.effective_status),
        toggled: adDetails.effective_status === 'ACTIVE',
        onToggle: function onToggle(event, state) {
          return _this2.props.setAdStatus(_this2.props.organization.id, adDetails.id, state);
        }
      })))), ' '), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        },
        onClick: handleCardClick
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap,
        style: !displayRightData || this.props.type && this.props.type === 'upcoming' ? {
          flex: '0 0 calc(100% - 20px)'
        } : null
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.adCardPreview
      }, !!imageUrl && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(imageUrl, ")")
        },
        className: styles.imgWrap
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.adTextWrap
      }, creative.title && /*#__PURE__*/React.createElement("span", {
        className: styles.title
      }, creative.title), /*#__PURE__*/React.createElement("span", {
        style: creative.title ? {
          marginBottom: 4
        } : {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.description
      }, creative.body)), /*#__PURE__*/React.createElement("div", {
        className: styles.previewBottomRow
      }, /*#__PURE__*/React.createElement("i", {
        className: styles.networkIcons
      }, /*#__PURE__*/React.createElement(SocialNetworkIcon, {
        network: 'facebook',
        size: 'small'
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.dates
      }, "".concat(moment(adDetails.campaign.start_time).format('M/DD/YY'), " - ").concat(moment(adDetails.campaign.stop_time).format('M/DD/YY'))))))), displayRightData && /*#__PURE__*/React.createElement("div", {
        className: styles.rightPaneWrap
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: styles.statWrap
      }, !!defaultPlatformInsights.impressions && !isNaN(parseInt(defaultPlatformInsights.impressions)) && /*#__PURE__*/React.createElement(Stat, {
        size: "small",
        topTextColor: "secondaryColor",
        topText: this.formatNumber(parseInt(defaultPlatformInsights.impressions)),
        bottomText: "Impressions",
        style: {
          margin: '12px 0'
        },
        theme: this.props.theme
      }), !!defaultPlatformInsights.cpc && !isNaN(parseFloat(defaultPlatformInsights.cpc)) && /*#__PURE__*/React.createElement(Stat, {
        size: "small",
        topTextColor: "secondaryColor",
        topText: "".concat(this.formatCurrency(parseFloat(defaultPlatformInsights.cpc))),
        bottomText: "Per Click",
        style: {
          margin: '12px 0'
        },
        theme: this.props.theme
      }), !!defaultPlatformInsights.spend && !isNaN(parseFloat(defaultPlatformInsights.spend)) && /*#__PURE__*/React.createElement(Stat, {
        size: "small",
        topTextColor: "secondaryColor",
        topText: "".concat(this.formatCurrency(parseFloat(defaultPlatformInsights.spend))),
        bottomText: "Spent",
        style: {
          margin: '12px 0'
        },
        theme: this.props.theme
      }))))), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          title: /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("div", {
            className: "row"
          }, /*#__PURE__*/React.createElement("div", {
            className: "col-xs-9"
          }, /*#__PURE__*/React.createElement(AdTypeIcon, {
            style: {
              "float": 'left',
              marginRight: 8
            },
            adType: adDetails.campaign.objective,
            size: "large"
          }), /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: 22,
              color: 'rgb(97, 97, 97)',
              fontWeight: 400
            }
          }, "".concat(_this2.formatObjective(adDetails.campaign.objective), " - ").concat(adDetails.name))))),
          autoScrollBodyContent: true,
          open: _this2.state.showDetails,
          onRequestClose: handleCardClick,
          actions: modalActions,
          actionsContainerStyle: {
            padding: 12
          },
          bodyStyle: {
            padding: 0
          },
          contentStyle: {
            maxWidth: 1200,
            width: '97%'
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(AdDetails, {
          adDetails: _this2.props.adDetails,
          upcoming: _this2.props.type === 'upcoming'
        })));
      }));
    }
  }]);

  return AdDashboardCard;
}(Component), _defineProperty(_class2, "propTypes", {
  adDetails: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  style: {}
}), _temp)) || _class);
export default AdDashboardCard;